import React from "react";
import PropTypes from "prop-types";
import { IconButton, withStyles } from "@material-ui/core";
import PlayArrow from "@material-ui/icons/PlayArrow";
import Pause from "@material-ui/icons/Pause";
import FastRewind from "@material-ui/icons/FastRewind";
import FastForward from "@material-ui/icons/FastForward";
import GetApp from "@material-ui/icons/GetApp";
import moment from "moment";
import Slider from "@appigram/react-rangeslider";

import { Flex } from "../../_common";
import "./AudioPlayer.css";

const CHANGE_RATIO = 0.25;
const MIN_SPEED = 0.25;
const MAX_SPEED = 2;

function AudioPlayer({ source, duration, classes }) {
  const [playing, setPlaying] = React.useState(false);
  const [speed, setSpeed] = React.useState(1);
  const [playbackPosition, setPlaybackPosition] = React.useState(0);
  const audioRef = React.useRef();

  function changeSpeed(ratio) {
    if (ratio > 0) setSpeed(s => Math.min(MAX_SPEED, s + CHANGE_RATIO * ratio));
    else setSpeed(s => Math.max(MIN_SPEED, s + CHANGE_RATIO * ratio));
  }

  React.useEffect(() => {
    audioRef.current.onended = () => setPlaying(false);
    audioRef.current.ontimeupdate = () => setPlaybackPosition(audioRef.current.currentTime);
  }, []);

  React.useEffect(
    () => {
      if (playing) audioRef.current.play();
      else {
        audioRef.current.pause();
        setSpeed(1);
      }
    },
    [playing]
  );

  React.useEffect(
    () => {
      audioRef.current.playbackRate = speed;
    },
    [speed]
  );

  return (
    <div style={{ height: 54, paddingTop: 8, display: "flex", alignItems: "center" }}>
      <audio ref={audioRef} preload>
        <source src={source} type="audio/mpeg" />
      </audio>
      <IconButton classes={{ root: classes.icons }} onClick={() => changeSpeed(-1)}>
        <FastRewind className={speed < 1 && classes.active} />
      </IconButton>
      <IconButton classes={{ root: classes.icons }} onClick={() => setPlaying(p => !p)}>
        {playing ? <Pause /> : <PlayArrow />}
      </IconButton>
      <IconButton classes={{ root: classes.icons }} onClick={() => changeSpeed(1)}>
        <FastForward className={speed > 1 && classes.active} />
      </IconButton>
      <Flex style={{ paddingLeft: 8, paddingRight: 8 }}>
        <p style={{ alignSelf: "center", margin: 0, paddingRight: 8 }}>
          {moment.utc(moment.duration(playbackPosition, "seconds").asMilliseconds()).format("mm:ss")} /{" "}
          {moment.utc(moment.duration(duration, "seconds").asMilliseconds()).format("mm:ss")}
        </p>
        <Slider
          orientation="horizontal"
          value={playbackPosition}
          onChange={v => {
            audioRef.current.currentTime = v;
          }}
          onChangeStart={() => setPlaying(false)}
          onChangeComplete={() => setPlaying(true)}
          min={0}
          max={moment.duration(duration).as("seconds")}
          step={1}
          tooltip={false}
        />
      </Flex>
      <IconButton onClick={() => window.open(source, "_blank")} classes={{ root: classes.icons }}>
        <GetApp />
      </IconButton>
    </div>
  );
}

AudioPlayer.propTypes = {
  source: PropTypes.string,
  duration: PropTypes.number,
  classes: PropTypes.object,
};

export default withStyles({
  icons: {
    padding: 0,
  },
  active: {
    border: "1px solid #a6c7ff",
  },
})(AudioPlayer);
